import React from 'react';
import { Box, Skeleton } from '@mui/material';

export const SelectLoadingLayout = () => {
    return (
        <Box sx={{ width: '100%' }}>
            <Skeleton variant="rectangular" height={50} />
        </Box>
    );
};
